import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  
  url = environment.apiConfig.baseUrl; // Remove /api suffix for base URL
  //url = 'http://localhost:3000'
  constructor(private _http: HttpClient) { }
  
  graphMeCall() {
    return this._http.get<any>('https://graph.microsoft.com/v1.0/me');
  }

  getAllInventory() {
    return this._http.get<any[]>(this.url + '/enac/inventory/all');
  }

  getInventoryBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/inventory/serial/' + serialNumber);
  }

  // Sets the Gold Source device (masterConfig) by serial number.
  // Backend should mark this device as masterConfig=1 and clear others.
  setGoldSource(serialNumber: string) {
    return this._http.put<any>(this.url + '/enac/inventory/gold-source/' + serialNumber, {});
  }

  getInterfaceBySerial(serialNumber: string) {
    return this._http.get<any[]>(this.url + '/enac/interface/' + serialNumber);
  }

  getDnsBySerial(serialNumber: string) {
    return this._http.get<any[]>(this.url + '/enac/dns/' + serialNumber);
  }

  getGroupsBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/groups/' + serialNumber);
  }

  getGroupRootBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/groups/root/' + serialNumber);
  }

  getGroupMembersBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/members/' + serialNumber);
  }

  getNetworksBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/network/' + serialNumber);
  }

  getAsmsDataBySerial(serialNumber: string) {
    return this._http.get<any>(this.url + '/enac/asms/' + serialNumber);
  }

  getTreeBySerial(serialNumber: string) {
    return this._http.get<any[]>(this.url + '/enac/tree/' + serialNumber);
  }
  getAsmsByGroupName(groupName: string) {
    return this._http.get<any>(this.url + '/enac/asms/group/' + groupName);
  }
}
